"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.OfferVehicleType = exports.OfferItemType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var OfferItemType = _propTypes["default"].shape({
  cardEyebrowText: _propTypes["default"].string,
  offerCode: _propTypes["default"].string,
  modelName: _propTypes["default"].string,
  trimCode: _propTypes["default"].string,
  offerType: _propTypes["default"].string,
  offerTypeDisplayName: _propTypes["default"].string,
  descriptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string,
    text: _propTypes["default"].string
  }))
});
exports.OfferItemType = OfferItemType;
var OfferVehicleType = _propTypes["default"].shape({
  vehicleName: _propTypes["default"].string,
  vehicleCode: _propTypes["default"].string,
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string,
  offers: _propTypes["default"].arrayOf(OfferItemType)
});
exports.OfferVehicleType = OfferVehicleType;